import 'isomorphic-fetch'; /* global fetch:false */
import { clientInfoToNestioFormat } from './clients';

export function getAvailableAppointmentTimes(dateString) {
  // Load either all legal appointment times, or just ones available on a given date.
  let timesPromise = fetch(
    `/appointment-times${dateString ? '?from_date=' + dateString : ''}`
  );

  return timesPromise
    .then((response) => {
      if (!response.ok) throw new Error('Nestio reported an error.');

      return response.json();
    })
    .then((json) => json.available_times);
}

export function bookAppointment(
  dateMoment,
  localTimeString,
  allowSms,
  clientData,
  tour,
  platform,
  url_params
) {
  clientData.url_params = url_params;
  const clientDataFormatted = clientInfoToNestioFormat(
    clientData,
    'widget',
    'Website'
  );
  // console.log('posted data: ', clientDataFormatted);
  const layoutMap = {
    10: 'studio',
    20: '1br',
    30: '2br',
  };
  return fetch('/book', {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      appointment: {
        start: `${dateMoment.format('YYYY-MM-DD')}T${localTimeString}`,
        expiration_date: null,
        tour_type: 'guided',
        is_video_tour: tour,
        platform_of_choice: tour ? platform : '',
        location: '300 Ashland Place',
        // false even in the official widget's POST when you say you're a broker.
        broker_booked: false,
      },
      client: {
        ...clientDataFormatted.client,
        layout: [layoutMap[clientDataFormatted.client.layout[0]]],
        campaign_info: null,
        notes: clientDataFormatted.client.campaign_info,
        sms_opted_in: allowSms,
        client_referral: 'Company Website',
      },
    }),
  }).then((response) => {
    if (!response.ok) {
      throw new Error('Nestio reported an error.');
    }

    return true;
  });
}



// WEBPACK FOOTER //
// ./client/services/appointments.js